import { render, staticRenderFns } from "./UserTabOverview.vue?vue&type=template&id=4ffc88be&scoped=true&"
import script from "./UserTabOverview.vue?vue&type=script&lang=js&"
export * from "./UserTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserTabOverview.vue?vue&type=style&index=0&id=4ffc88be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc88be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VTimeline,VTimelineItem})
